/**
 * @constant 公共flag
 */
export const COMMON_FLAG = {
  yes: 1,
  no: 2
}

/**
 * @constant 组件类型
 */
export const COMPONENTS_TYPE = {
  demo: 'demo', // 演示组件
  payment: 'payment', // 支付组件
}